import React, {useEffect, useState} from 'react';
import {Button, withStyles,} from '@material-ui/core';
import {SaveIcon} from "../../../../../helpers/Icons";
import {Cancel, Comment} from "@mui/icons-material";
import TextField from "@material-ui/core/TextField";
import ToolbarButtonGroup from "../../../../../helpers/ToolbarButtonGroup";
import DateDisplay from "../../../../../helpers/common/DateDisplay";

const styles = {
  root: {
    flex: 1,
  },
  comment: {
    display: "flex",
    flexDirection: "column",
    // gap: "0.5rem",
    marginBottom: "0.5rem"
  },
  label: {
    display: "flex",
    fontWeight: 600,
    fontSize: "0.7225rem",
    color: "#003e58",
    textTransform: "uppercase",
  },
  commentDate: {
    marginLeft: "0.25rem",
    display:"flex",
    fontWeight: 400,
  },
  commentText: {
    whiteSpace: "pre-wrap",
    fontWeight: 300,
  },
  addCommentBtn: {},
  commentContainer: {},
  commentField: {},
  saveComment: {},
}

function QuestionComment(props) {
  const { comment, commentDate, setComment, commentOpen, setCommentOpen, isViewingShared, classes } = props;

  const [text, setText] = useState(comment);
  useEffect(() => {
    if(comment !== text) {
      setText(comment);
    }else if(commentOpen){
      setCommentOpen(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [comment]);

  const saveComment = () => {
    setComment(text);
  }

  return (
    <div id={"commentSection"} className={classes.root}>
      {comment?.trim?.() === "" ? null :
        <div className={classes.comment}>
          <div className={classes.label}>
            Comment{!!commentDate ? <span id="commentDate" className={classes.commentDate}>(<DateDisplay date={commentDate} timeSize="large"/>)</span> : null}:
          </div>
          <div id="questionComment" className={classes.commentText}>
            {comment}
          </div>
        </div>
      }
      {isViewingShared ? null : <>
        <ToolbarButtonGroup style={{flexWrap: "nowrap", width: "206px", textAlign: "right", backgroundColor: "#fff",}}>
          <Button
            id={!comment ? "addComment" : "editComment"}
            className={`${commentOpen ? classes.toolbarButtonOpen : classes.toolbarButton} ${classes.addCommentBtn}`}
            onClick={() => setCommentOpen(!commentOpen)}
            startIcon={<Comment />}
          >{!comment ? "Add Comment" : "Edit Comment"}</Button>
        </ToolbarButtonGroup>
        {!commentOpen ? null :
          <div id="commentFormSection" className={classes.commentContainer}>
            <TextField
              id={"commentField"}
              className={classes.commentField}
              size="small"
              multiline
              minRows={3}
              variant="outlined"
              label="Comment"
              value={text}
              onChange={e => setText(e.target.value)}
              style={{ width: "100%", margin: "0.5rem 0"}}
            />
            <Button
              id="commentSave"
              onClick={saveComment}
              variant="contained"
              color="primary"
              size={"small"}
              margin={"dense"}
              startIcon={<SaveIcon />}
              style={{marginRight: "0.5rem"}}
            >Save Comment</Button>
            <Button
              id="commentCancel"
              onClick={() => {
                setCommentOpen(false);
                setText(comment);
              }}
              variant="contained" color="secondary"
              size={"small"}
              startIcon={<Cancel />}
            >Cancel</Button>
          </div>
        }
      </>}
    </div>
  )
}

export default withStyles(styles)(QuestionComment);